import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getTaxRates } from "../../api/apiTax";

export const useGetTaxRates = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["tax-rates", params, i18next.language],
        queryFn: () => getTaxRates(params),
        keepPreviousData: true,
    });

    const rates = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params?.per_page || 15, total: 0 };

    return { isLoading, error, rates, meta, refetch };
};
